/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { workspacesGetComplianceReport } from "../../funcs/workspacesGetComplianceReport.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request:
    operations
      .GetApiWorkspaceServiceV1WorkspacesComplianceReportWorkspaceIdRequest$inboundSchema,
};

export const tool$workspacesGetComplianceReport: ToolDefinition<typeof args> = {
  name: "workspaces_get-compliance-report",
  description: `Get compliance report`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await workspacesGetComplianceReport(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
